module.exports = __webpack_public_path__ + "static/media/JQuery_logo.64dd08ca.png";